import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class InfoTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Camera Overview" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { actionColumn: 'Camera ID', descriptionColumn: 'Model number of your camera.' },
        { actionColumn: 'Firmware Version', descriptionColumn: 'Version of your camera´s operating system. You can always find the newest version of the Firmware/WebUI in our Download Area. The software is uploaded to your camera through the Update Menu.' },
        { actionColumn: 'WebUI Version', descriptionColumn: 'Version of your camera´s web user interface. You can always find the newest version of the Firmware/WebUI in our Download Area. The software is uploaded to your camera through the Update Menu.' },
        { actionColumn: 'Network Interface', descriptionColumn: 'Displays whether your camera is connected by WiFi or Ethernet cable.' },
        { actionColumn: 'MAC Address', descriptionColumn: 'Hardware identification of the active (LAN or WLAN) network interface.' },
        { actionColumn: 'SD Status', descriptionColumn: 'Displays if your camera´s SD card is ready for operation and its remaining capacity (the SD card is used as a ring buffer - the oldest folder is deleted once the capacity is reached).' },
        { actionColumn: 'IR LED Status', descriptionColumn: 'Operating mode of your night vision LEDs - either switched on automatically (when it is getting dark) or permanently deactivated.' },
        { actionColumn: 'WAN IP Address', descriptionColumn: 'Wide Area Network Address of your internet connection. This is the address that your DDNS Address will be translated to, to make your camera available from the internet (needs a Port Forwarding!).' },
        { actionColumn: 'DDNS Status', descriptionColumn: 'This function checks if your DDNS Address was successfully updated with your actual WAN IP Address. This is a requirement to Access your Camera from the Internet.' },
        { actionColumn: 'UPnP Status', descriptionColumn: 'The UPnP service automatically tries to set a Port Forwarding for the DDNS access to your camera. We recommend to Deactivate this Service and create a manual forwarding instead.' },
        { actionColumn: 'Camera active since', descriptionColumn: 'Up-time of your camera since the last reboot.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

InfoTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(InfoTable)